import axios from 'axios'

const apiCorreo = axios.create({
	baseURL: process.env.VUE_APP_URL_BASE,
	withCredentials: false,
	headers : {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	}
});

export default {
	enviar(param){
		return apiCorreo.post('send/',param);
	}
}